import { Component, OnInit } from '@angular/core';
import { InventarioService } from 'src/app/services/inventario.service';
import { ExcelService } from 'src/app/services/excel.service';

@Component({
  selector: 'app-listadodereportespersonal',
  templateUrl: './listadodereportespersonal.component.html',
  styleUrls: ['./listadodereportespersonal.component.css']
})
export class ListadodereportespersonalComponent implements OnInit {

  plantilla: any[] = [];           // datos cargados desde backend según plantel
  plantillaOriginal: any[] = [];   // copia completa
  resultados: any[] = [];

  planteles: any[] = [];
  plantelSeleccionado: number = -1; // -1 = Todos, 0 = Dirección General
  filtroNombre: string = '';

  yaBusco: boolean = false;

  constructor(
    private inventarioService: InventarioService,
    private excelService: ExcelService
  ) { }

  ngOnInit(): void {
    this.cargarPlanteles();
  }

  cargarPlanteles() {
    // Cargar todos los planteles
    // Usa tu método de InventarioService para traer todos los planteles
    this.inventarioService.getTodosPlanteles().subscribe(
      (res: any) => { this.planteles = res || []; },
      err => { console.error('Error cargando planteles:', err); this.planteles = []; }
    );
  }

  buscarReportes() {
    this.yaBusco = true;

    let idPlantelBackend: number;

    if (this.plantelSeleccionado === -1) {
      // Todos
      idPlantelBackend = -1;
    } else {
      // Dirección General = 0 o plantel específico
      idPlantelBackend = this.plantelSeleccionado;
    }

    this.inventarioService.getPlantillaempleadosExcel(idPlantelBackend).subscribe(
      (res: any) => {
        this.plantilla = res || [];
        this.plantillaOriginal = [...this.plantilla];

        this.aplicarFiltroNombre();
      },
      err => {
        console.error(err);
        this.plantilla = [];
        this.resultados = [];
      }
    );
  }

  aplicarFiltroNombre() {
    const termino = (this.filtroNombre || '').trim().toLowerCase();
    if (!termino) {
      this.resultados = [...this.plantilla];
      return;
    }

    this.resultados = this.plantilla.filter((item: any) => {
      const nombre = (item['Nombre completo'] || '').toLowerCase();
      const numemp = (item['Número de empleado'] || '').toString().toLowerCase();
      return nombre.includes(termino) || numemp.includes(termino);
    });
  }

  exportPlantillaempleadofXLSX(): void {
    this.excelService.exportAsExcelFile(this.plantilla, 'Excel_plantilla_personal');
  }

  exportPlantillaFiltradaXLSX(): void {
    const dataToExport = this.resultados.length > 0 ? this.resultados : this.plantilla;
    this.excelService.exportAsExcelFile(dataToExport, 'Excel_plantilla_filtrada');
  }

}
